<template>
    <div v-if="visible" class="sidebar">
      <h3>Asset Details</h3>
      <img :src="getAssetImage(asset.imagepath)" alt="Asset Image" class="asset-image" />
      <div class="details">
        <p><strong>Device Name:</strong> {{ asset.devicename }}</p>
        <p><strong>Tag ID:</strong> {{ asset.tag_mac }}</p>
        <p><strong>Device Type:</strong> {{ asset.devicetype }}</p>
        <p><strong>Temp: </strong> 
            <span class="temperature-value">
                {{ asset.tag_temperature }} °C
            </span>
            
        </p>
        <p>
            <strong>Battery: </strong> 
            <span :class="getBatteryClass(asset.tag_vol)" >
              {{ asset.tag_vol >= 2.7 ? 'Good' : asset.tag_vol >= 2.3 ? 'Mid' : 'None' }}
            </span>
            <span class="battery-value"> ({{ asset.tag_vol.toFixed(1) }}v)</span>
        </p>
        <p><strong>RSSI: </strong><span v-if="Math.abs(asset.tag_rssi) <= 70">
            <span class="material-symbols-outlined rssi-good" style="font-size: 24px;">signal_cellular_alt</span>
            </span>
            <span v-else>
              <span class="material-symbols-outlined rssi-mid" style="font-size: 24px;">signal_cellular_alt_2_bar</span>
            </span>
        </p>
        <p><strong>Building:</strong> {{ asset.building }}</p>
        <p><strong>Floor:</strong> {{ asset.floor }}</p>
        <p><strong>Last Scanned Zone:</strong> {{ asset.taglocation }}</p>
        <p><strong>Assigned Zone:</strong> {{ asset.assignedzone }}</p>
      </div>
      <button @click="closeSidebar">Close</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'EventTagSidebar',
    props: {
      visible: Boolean,
      asset: Object,
    },
    methods: {
      closeSidebar() {
        this.$emit('close');
      },
      getAssetImage(imagePath) {
        if (!imagePath) {
          // 이미지 경로가 null일 경우 기본 이미지 경로를 반환
          return require('@/assets/inventory.png'); // 기본 이미지 파일 경로로 변경
        }
        
        try {
          return require(`@/assets/${imagePath}`);
        } catch (error) {
          console.error('Image not found:', error);
          return require('@/assets/inventory.png'); // 또 다른 기본 이미지 경로
        }
      },
      getBatteryClass(vol) {
       if (vol >= 2.7) {
        return 'battery_good'; // Good
       } else if (vol >= 2.3) {
        return 'battery_mid'; // Mid
       } else {
        return 'battery_none'; // None
      }
     },
    },
  };
  </script>
  
  <style scoped>
  .sidebar {
    position: fixed;
    top: 0;
    right: 0;
    width: 300px;
    height: 100%;
    background-color: #f8f9fc;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
    padding: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
  }
  
  h3 {
    margin-bottom: 20px;
  }
  
  .asset-image {
    width: 100%; /* 이미지 너비를 100%로 설정하여 사이드바에 맞춤 */
    height: auto; /* 자동으로 높이 조정 */
    margin-bottom: 20px; /* 이미지와 내용 사이의 간격 */
  }
  
  .details {
    flex-grow: 1;
    overflow-y: auto; /* 내용이 넘칠 경우 스크롤 가능 */
  }
  
  strong {
    font-weight: bold;
  }
  
  button {
    align-self: flex-end; /* 버튼을 오른쪽 정렬 */
    padding: 10px 15px;
    background-color: #4e73df;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 40px; 
  }
  
  button:hover {
    background-color: #2e59d9;
  }

  
    .rssi-good {
    color: green;
    }

    .rssi-mid {
    color: orange;
    }

    .rssi-low {
    color: red;
    }

    .battery_good {
    color: green;
    font-weight: bold;
    }

    .battery_mid {
    color: orange;
    font-weight: bold;
    }

    .battery_none {
    color: skyblue;
    font-weight: bold;
    }
    .temperature-value{
    color:red;
    }
  </style>
  